import {ref} from 'vue'

/**
 * Loading composable
 */
export const useLoading = (initialValue = false) => {

  //Refs
  const isLoading = ref(initialValue)

  //Mutator
  const setLoading = value => isLoading.value = value

  //Expose interface
  return {
    isLoading,
    setLoading,
  }
}
